import { Injectable, inject } from '@angular/core';

import { Store } from '@ngrx/store';
import { BehaviorSubject, take } from 'rxjs';

import { RegionsStoreService } from '@core/country-data';
import type { CountryRegion } from '@core/locations-types';
import type { SelectOption } from '@core/user-interface-legacy';

@Injectable()
export class DynamicFormLocationsService {
  private readonly regionStoreService = inject(RegionsStoreService);
  private readonly store = inject(Store);

  public loadingRegions$: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public regions$: BehaviorSubject<Array<SelectOption<string>>> = new BehaviorSubject(null!);

  public getRegionsCollection(countryCode: string): void {
    this.loadingRegions$.next(true);
    this.regionStoreService
      .getOrLoadCountryRegions(countryCode)
      .pipe(take(1))
      .subscribe((regions: CountryRegion[]) => {
        const regionOptions = <Array<SelectOption<string>>>(
          regions.map((region: CountryRegion) => ({ label: region.name, value: region.code }))
        );
        this.regions$.next(regionOptions);
        this.loadingRegions$.next(false);
      });
  }
}
